// extracted by mini-css-extract-plugin
module.exports = {"MenuSelectionHolder":"MenuSelection_MenuSelectionHolder__3UNYi","ImageHolder":"MenuSelection_ImageHolder__3dp00"};